require("core-js/modules/esnext.global-this.js");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).PureCache = t();
}(this, function () {
  "use strict";

  function e(e, t) {
    var i = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), i.push.apply(i, r);
    }

    return i;
  }

  function t(t) {
    for (var i = 1; i < arguments.length; i++) {
      var r = null != arguments[i] ? arguments[i] : {};
      i % 2 ? e(Object(r), !0).forEach(function (e) {
        o(t, e, r[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : e(Object(r)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
      });
    }

    return t;
  }

  function i(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function r(e, t) {
    for (var i = 0; i < t.length; i++) {
      var r = t[i];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function n(e, t, i) {
    return t && r(e.prototype, t), i && r(e, i), e;
  }

  function o(e, t, i) {
    return t in e ? Object.defineProperty(e, t, {
      value: i,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = i, e;
  }

  function s(e) {
    return {
      all: e = e || new Map(),
      on: function on(t, i) {
        var r = e.get(t);
        r ? r.push(i) : e.set(t, [i]);
      },
      off: function off(t, i) {
        var r = e.get(t);
        r && (i ? r.splice(r.indexOf(i) >>> 0, 1) : e.set(t, []));
      },
      emit: function emit(t, i) {
        var r = e.get(t);
        r && r.slice().map(function (e) {
          e(i);
        }), (r = e.get("*")) && r.slice().map(function (e) {
          e(t, i);
        });
      }
    };
  }

  var a = "expiry",
      u = "add",
      c = "get",
      h = "remove",
      f = "clear",
      l = function l(e) {
    if (e) throw new Error("Cannot use disposed instance.");
  },
      d = {
    expiryCheckInterval: 100
  },
      p = function () {
    function e() {
      var r = this,
          n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      i(this, e), o(this, "expire", function () {
        l(r.disposed);

        for (var e = Date.now(), t = e; t >= r.lastExpiredTime; t -= 1) {
          var i = r.queue[t];
          i && (delete r.queue[t], i.forEach(function (e) {
            var t = e.key;
            return (0, e.onExpire)(t);
          }));
        }

        r.lastExpiredTime = e;
      }), this.config = t(t({}, d), n), this.queue = {}, this.disposed = !1, this.lastExpiredTime = Date.now() - 1;
      var s = this.config.expiryCheckInterval;
      this.timer = setInterval(this.expire, s);
    }

    return n(e, [{
      key: "add",
      value: function value(e, t, i) {
        return l(this.disposed), this.queue[e] || (this.queue[e] = []), this.queue[e].push({
          key: t,
          onExpire: i
        }), !0;
      }
    }, {
      key: "remove",
      value: function value(e, t) {
        l(this.disposed);
        var i = this.queue[e];

        if (i) {
          var r = i.filter(function (e) {
            return e.key !== t;
          });
          return r.length ? this.queue[e] = r : delete this.queue[e], !0;
        }

        return !1;
      }
    }, {
      key: "dispose",
      value: function value() {
        return l(this.disposed), clearInterval(this.timer), this.timer = null, this.queue = {}, this.disposed = !0, !0;
      }
    }]), e;
  }(),
      v = {
    defaultCacheExpiryIn: 6e4,
    expiryCheckInterval: 100
  };

  return function () {
    function e() {
      var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : p;
      i(this, e), this.config = t(t({}, v), r);
      var o = s(),
          a = o.on,
          u = o.off,
          c = o.emit,
          h = [a, u, c];
      this.on = h[0], this.off = h[1], this.emit = h[2], this.cacheStore = {}, this.disposed = !1;
      var f = this.config.expiryCheckInterval;
      this.cacheExpirer = new n({
        expiryCheckInterval: f
      });
    }

    return n(e, [{
      key: "put",
      value: function value() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.config.defaultCacheExpiryIn;
        l(this.disposed), this.cacheStore[t] && this.remove(t);
        var n = Date.now(),
            o = r ? n + r : null,
            s = {
          value: i,
          addedAt: n,
          expiryAt: o
        };

        if (this.cacheStore[t] = s, o) {
          var c = function c() {
            e.remove(t), e.emit(a, {
              key: t,
              data: e.cacheStore[t]
            });
          };

          this.cacheExpirer.add(o, t, c);
        }

        return this.emit(u, {
          key: t,
          data: s
        }), s;
      }
    }, {
      key: "get",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        l(this.disposed);
        var t = this.cacheStore[e];
        return t ? (this.emit(c, {
          key: e,
          data: t
        }), t) : null;
      }
    }, {
      key: "remove",
      value: function value(e) {
        l(this.disposed);
        var t = this.cacheStore[e];

        if (t) {
          delete this.cacheStore[e];
          var i = t.expiryAt;
          return this.cacheExpirer.remove(i, e), this.emit(h, {
            key: e,
            data: t
          }), !0;
        }

        return !1;
      }
    }, {
      key: "dispose",
      value: function value() {
        var e = this;
        return l(this.disposed), Object.keys(this.cacheStore).forEach(function (t) {
          return e.remove(t);
        }), this.emit(f, {}), this.cacheExpirer.dispose(), this.disposed = !0, !0;
      }
    }]), e;
  }();
});